// extracted by mini-css-extract-plugin
export default {"cell":"hoverableStyles_cell__GwHSi","hoverableCell":"hoverableStyles_hoverableCell__nq9dr"};